import axios from "axios";
import { PROVIDERS_REVIEWS_ADMIN } from "../../../../../config";
import { DataTableHelper } from "../../../../../utilities/helpers/DataTableHelper";

export function getProviderReviews(
	sortParam,
	pageSize,
	pageNumber
) {
	return axios.get(
		PROVIDERS_REVIEWS_ADMIN +
			( DataTableHelper.prepareParameters(
				sortParam,
				pageSize,
				pageNumber,
		)),
	);
}

export function getReviewDetails(id) {
	return axios.get(PROVIDERS_REVIEWS_ADMIN + '/' +id);
}